import React from "react";
import { useClasses } from "../../../";
import classNames from "classnames";
import Suggestions from "./Suggestions";
export const styles = (theme) => {
    return {
        inputHolder: {
            padding: "18px 0px 0px 0px",
        },
        inlineHolder: {
            "@media print": {
                padding: "18px 0px 0px 0px",
            },
        },
        input: {
            display: "block",
            width: "100%",
            height: "32px",
            boxSizing: "border-box",
            backgroundColor: theme.palette.get("formBackground"),
            outline: "none",
            border: "none",
            borderRadius: "2px",
            padding: "5px 8px  5px 8px",
            fontSize: "1rem",
            textOverflow: "ellipsis",
            overflow: (props) => props.rows ? "auto" : "hidden",
            whiteSpace: (props) => props.rows ? "normal" : "nowrap",
            "&:focus": {
                backgroundColor: theme.palette.get("formBackgroundActive"),
                transition: "background-color 150ms linear",
            },
        },
        inputReadOnly: {
            backgroundColor: "rgba(0, 0, 0, 0)",
            padding: "5px 8px  5px 2px",
            "&:focus": {
                backgroundColor: "rgba(0, 0, 0, 0)",
            },
        },
        textarea: {
            display: "block",
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: theme.palette.get("formBackground"),
            outline: "none",
            border: "none",
            borderRadius: "2px",
            padding: "5px 8px  5px 8px",
            fontSize: "1rem",
            textOverflow: "ellipsis",
            resize: "none",
            "&:focus": {
                backgroundColor: theme.palette.get("formBackgroundActive"),
                transition: "background-color 150ms linear",
            },
        },
        hasError: {
            color: "rgba(156, 0, 0, 1)",
        },
        suggestItem: {},
    };
};
function Input(props) {
    const { autoFocus, inline, label, readOnly = false, value, onChange, rows = false, type, autoComplete = "off", override = {}, setFocus, textAreaRef, inputRef, hasError, } = props;
    const classes = useClasses(styles);
    return (React.createElement("div", { className: classNames([
            inline ? classes.inlineHolder : classes.inputHolder,
        ]) },
        !rows && (React.createElement("input", { autoFocus: autoFocus, className: classNames([
                classes.input,
                readOnly && classes.inputReadOnly,
                hasError && classes.inputError,
                override.input,
            ]), placeholder: props.placeholder, name: props.name || label, ref: inputRef, value: value || "", type: type, autoComplete: autoComplete, onChange: (e) => {
                if (readOnly || !onChange)
                    return;
                else if (typeof e.target.value === "string" &&
                    e.target.value !== "")
                    onChange(e.target.value);
                else
                    onChange();
            }, onFocus: (e) => {
                if (props.onFocus)
                    props.onFocus(e);
                setFocus(true);
            }, onBlur: (e) => {
                const target = e.relatedTarget;
                if (!target || !target.classList.contains(classes.suggestItem)) {
                    if (props.onBlur)
                        props.onBlur(e);
                    setFocus(false);
                }
            } })),
        Boolean(rows) && (React.createElement("textarea", { autoFocus: autoFocus, rows: rows || 1, className: classNames([
                classes.textarea,
                hasError && classes.inputError,
                override.input,
            ]), name: label, ref: textAreaRef, value: value || "", placeholder: props.placeholder, onChange: (e) => {
                if (readOnly || !onChange)
                    return;
                else if (typeof e.target.value === "string" &&
                    e.target.value !== "")
                    onChange(e.target.value);
                else
                    onChange();
            }, onFocus: (e) => {
                if (props.onFocus)
                    props.onFocus(e);
                setFocus(true);
            }, onBlur: (e) => {
                const target = e.relatedTarget;
                if (!target || !target.classList.contains(classes.suggestItem)) {
                    if (props.onBlur)
                        props.onBlur(e);
                    setFocus(false);
                }
            } })),
        React.createElement(Suggestions, { suggestions: props.suggestions, onSelect: props.onSuggestionSelect, identifyer: classes.suggestItem, override: props.override })));
}
export default Input;
